function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const { trackBigBrainEventOnServer } = require("../bigbrain-tracking-service/bigbrain-tracking-service");
const { JOB_SOURCE_ASHBY, ASHBY_API_BASE } = require("../../../components/pages/careers/careers-constants");
const { LAST_ACCOUNT_SLUG } = require("../../../constants/cookies");
const { logInfo } = require("../../logging/logger");
const ASHBY_ENV_ENABLED = process.env.ENABLE_ASHBY !== "false";
const MONDAY_ACCOUNT_SLUG = "monday";
const getLastLoginAccountFromRequest = (req)=>{
    var _req_headers;
    const cookieHeader = req === null || req === void 0 ? void 0 : (_req_headers = req.headers) === null || _req_headers === void 0 ? void 0 : _req_headers.cookie;
    if (!cookieHeader) return undefined;
    const match = cookieHeader.match(new RegExp(`(?:^|;\\s*)${LAST_ACCOUNT_SLUG}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined;
};
const isAshbyEnabledForRequest = (req)=>{
    if (!ASHBY_ENV_ENABLED) return false;
    if (!req) return false;
    const lastLoginAccount = getLastLoginAccountFromRequest(req);
    // TODO: TEMPORARY — open Ashby to everyone for quick QA
    // Revert to monday-only by uncommenting the line below and removing `const isEnabled = true;`.
    // const isEnabled = lastLoginAccount === MONDAY_ACCOUNT_SLUG;
    const isEnabled = true;
    logInfo("Ashby feature flag check", {
        lastLoginAccount,
        isEnabled
    });
    return isEnabled;
};
const getAuthHeader = (apiKey)=>{
    const encoded = Buffer.from(`${apiKey}:`).toString("base64");
    return `Basic ${encoded}`;
};
const getAshbyHeaders = function() {
    var _ref = _async_to_generator(function*() {
        const { get } = require("../../../secrets-service");
        const { api_token: apiKey } = yield get("ashby");
        return {
            "Content-Type": "application/json",
            Authorization: getAuthHeader(apiKey)
        };
    });
    return function getAshbyHeaders() {
        return _ref.apply(this, arguments);
    };
}();
const getAshbyPosition = function() {
    var _ref = _async_to_generator(function*(postingId, req) {
        if (!isAshbyEnabledForRequest(req)) {
            return {
                ERROR: "Ashby disabled",
                status: 404
            };
        }
        const headers = yield getAshbyHeaders();
        trackBigBrainEventOnServer("career_positions_retrieve_from_ashby", {
            kind: "single_position",
            info1: postingId
        });
        const response = yield fetch(`${ASHBY_API_BASE}/jobPosting.info`, {
            method: "POST",
            headers,
            body: JSON.stringify({
                jobPostingId: postingId
            })
        });
        const data = yield response.json();
        if (!data.success) {
            return {
                ERROR: `POSITION ${postingId} NOT FOUND`,
                status: response.status,
                message: data.errors
            };
        }
        return data.results;
    });
    return function getAshbyPosition(postingId, req) {
        return _ref.apply(this, arguments);
    };
}();
const getAshbyPositions = function() {
    var _ref = _async_to_generator(function*(req) {
        if (!isAshbyEnabledForRequest(req)) {
            return [];
        }
        const headers = yield getAshbyHeaders();
        trackBigBrainEventOnServer("career_positions_retrieve_from_ashby", {
            kind: "all_positions"
        });
        const response = yield fetch(`${ASHBY_API_BASE}/jobPosting.list`, {
            method: "POST",
            headers,
            body: JSON.stringify({
                listedOnly: true
            })
        });
        const data = yield response.json();
        if (!data.success) {
            return {
                ERROR: "Failed to fetch positions from Ashby",
                status: response.status,
                message: data.errors
            };
        }
        return data.results;
    });
    return function getAshbyPositions(req) {
        return _ref.apply(this, arguments);
    };
}();
const normalizeAshbyPosition = (ashbyPosition)=>{
    return {
        name: ashbyPosition.title,
        uid: ashbyPosition.id,
        department: ashbyPosition.departmentName || ashbyPosition.teamName || "",
        location: {
            name: ashbyPosition.locationName || "",
            city: ashbyPosition.locationName || ""
        },
        employment_type: ashbyPosition.employmentType || "",
        source: JOB_SOURCE_ASHBY
    };
};
const getAshbyPositionDetailsByID = function() {
    var _ref = _async_to_generator(function*(postingId, req) {
        const position = yield getAshbyPosition(postingId, req);
        if (position && !position.ERROR) {
            var _position_team, _position_department, _position_location;
            const teamName = position.teamName || ((_position_team = position.team) === null || _position_team === void 0 ? void 0 : _position_team.name) || "";
            const departmentName = position.departmentName || ((_position_department = position.department) === null || _position_department === void 0 ? void 0 : _position_department.name) || "";
            const locationName = position.locationName || ((_position_location = position.location) === null || _position_location === void 0 ? void 0 : _position_location.name) || "";
            return {
                department: departmentName || teamName,
                departmentName,
                title: position.title,
                location: locationName,
                positionDescription: position.descriptionHtml || "",
                positionRequirements: "",
                positionResponsibilities: "",
                socialTitle: position.title,
                socialDescription: "",
                employmentType: position.employmentType || "",
                teamDescription: "",
                positionTypeValue: null,
                source: JOB_SOURCE_ASHBY,
                applyLink: position.applyLink || "",
                applicationFormDefinition: position.applicationFormDefinition || null
            };
        }
        return {
            ERROR: `POSITION ${postingId} NOT FOUND`,
            status: position === null || position === void 0 ? void 0 : position.status,
            message: position === null || position === void 0 ? void 0 : position.message
        };
    });
    return function getAshbyPositionDetailsByID(postingId, req) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getAshbyPositions,
    getAshbyPosition,
    normalizeAshbyPosition,
    getAshbyPositionDetailsByID,
    isAshbyEnabledForRequest
};
